import { ContactSlugEnum, CountryEnum } from '@systemeio/ui'
import { contactAdditionalFilters } from 'modules/contacts/constants/contact-filter-titles'
import {
  ContactFilterConditionEnum,
  ContactFilterTagConditionEnum,
  ContactSearchFieldEnum,
} from 'modules/contacts/enums/contact-enum'
import {
  ContactFieldApiInterface,
  ContactFilterConditionInterface,
  ContactFilterContactStateInterface,
  ContactFilterDateInterface,
  ContactFilterRemovedReasonInterface,
  ContactFilterTagInterface,
  ContactFilterTextInterface,
  ContactFilterType,
} from 'modules/contacts/types/contact-filter-interface'
import { isFilterFiledEmpty } from 'modules/contacts/utils/is-filter-filed-empty'

export const getConditions = ({
  filter,
  filterFields,
}: {
  filter: ContactFilterType
  filterFields?: ContactFieldApiInterface
}): ContactFilterConditionInterface[] =>
  Object.keys(filter)
    .filter(el => !isFilterFiledEmpty({ filter, slug: el }))
    .flatMap(el => {
      const fieldId = filterFields?.items.find(e => e.slug === el)
      if (fieldId) {
        if (fieldId.slug === ContactSlugEnum.Country) {
          const countryArray: ContactFilterConditionInterface[] = []
          filter[el].forEach(item => {
            if (item === undefined) return
            countryArray.push({
              searchField: fieldId.id.toString(),
              searchValue: (item as CountryEnum) || null,
              compareOperation: ContactFilterConditionEnum.equals,
            })
          })
          return countryArray
        } else {
          const filterArray: ContactFilterConditionInterface[] = []
          filter[el].forEach(item => {
            const textFilterItem = item as ContactFilterTextInterface
            if (textFilterItem.compareOperation === ContactFilterConditionEnum.not_set) {
              filterArray.push({
                searchField: fieldId.id.toString(),
                searchValue: null,
                compareOperation: textFilterItem.compareOperation,
              })
            } else {
              if (textFilterItem.searchValue === '') return
              filterArray.push({
                searchField: fieldId.id.toString(),
                searchValue: textFilterItem.searchValue,
                compareOperation: textFilterItem.compareOperation,
              })
            }
          })
          return filterArray
        }
      } else {
        switch (el) {
          case ContactSearchFieldEnum.tag: {
            const tagFilterArray: ContactFilterConditionInterface[] = []
            filter[el].forEach(item => {
              const tagFilterItem = item as ContactFilterTagInterface
              if (tagFilterItem.compareOperation === ContactFilterTagConditionEnum.without) {
                tagFilterArray.push({
                  searchValue: null,
                  compareOperation: tagFilterItem.compareOperation,
                  searchField: contactAdditionalFilters.tag,
                })
              } else if (tagFilterItem.searchValue) {
                tagFilterArray.push({
                  searchValue: tagFilterItem.searchValue.toString(),
                  compareOperation: tagFilterItem.compareOperation,
                  searchField: contactAdditionalFilters.tag,
                })
              }
            })
            return tagFilterArray
          }
          case ContactSearchFieldEnum.created_at: {
            const dateFilterArray: ContactFilterConditionInterface[] = []
            filter[el].forEach(item => {
              const dateFilterItem = item as ContactFilterDateInterface
              if (dateFilterItem.searchValue === null) return
              dateFilterArray.push({
                searchValue: dateFilterItem.searchValue,
                compareOperation: dateFilterItem.compareOperation,
                searchField: contactAdditionalFilters.created_at,
              })
            })
            return dateFilterArray
          }
          case ContactSearchFieldEnum.removed_at: {
            const dateFilterArray: ContactFilterConditionInterface[] = []
            filter[el].forEach(item => {
              const dateFilterItem = item as ContactFilterDateInterface
              if (dateFilterItem.searchValue === null) return
              dateFilterArray.push({
                searchValue: dateFilterItem.searchValue,
                compareOperation: dateFilterItem.compareOperation,
                searchField: contactAdditionalFilters.removed_at,
              })
            })
            return dateFilterArray
          }
          case ContactSearchFieldEnum.removed_reason_type: {
            const removedFilterArray: ContactFilterConditionInterface[] = []
            filter[el].forEach(item => {
              const removeReasonFilterItem = item as ContactFilterRemovedReasonInterface
              if (removeReasonFilterItem.searchValue === undefined) return
              removedFilterArray.push({
                searchValue: removeReasonFilterItem.searchValue || undefined,
                searchField: contactAdditionalFilters.removed_reason_type,
                compareOperation: ContactFilterConditionEnum.equals,
              })
            })
            return removedFilterArray
          }
          case ContactSearchFieldEnum.last_activity_date: {
            const mailFilterArray: ContactFilterConditionInterface[] = []
            filter[el].forEach(item => {
              const mailFilterItem = item as { searchValue: string | null }
              if (mailFilterItem.searchValue === null) return

              mailFilterArray.push({
                searchValue: mailFilterItem.searchValue,
                compareOperation: ContactFilterConditionEnum.equals,
                searchField: contactAdditionalFilters.last_activity_date,
              })
            })
            return mailFilterArray
          }
          case ContactSearchFieldEnum.state: {
            const stateFilterArray: ContactFilterConditionInterface[] = []
            filter[el].forEach(item => {
              const stateFilterItem = item as ContactFilterContactStateInterface
              if (stateFilterItem.searchValue === undefined) return

              stateFilterArray.push({
                searchValue: stateFilterItem.searchValue || null,
                searchField: contactAdditionalFilters.state,
                compareOperation: ContactFilterConditionEnum.equals,
              })
            })
            return stateFilterArray
          }
          case ContactSearchFieldEnum.affiliate: {
            const affiliateFilterArray: ContactFilterConditionInterface[] = []
            filter[el].forEach(item => {
              const affiliateFilterItem = item as { searchValue: string }
              if (affiliateFilterItem.searchValue === '') return
              affiliateFilterArray.push({
                searchValue: affiliateFilterItem.searchValue,
                compareOperation: ContactFilterConditionEnum.equals,
                searchField: contactAdditionalFilters.affiliate,
              })
            })
            return affiliateFilterArray
          }
          default: {
            return {
              searchValue: null,
              searchField: '',
              compareOperation: ContactFilterConditionEnum.equals,
            }
          }
        }
      }
    })
